import React from 'react'
import Eula from '../eula'

const EulaDe = () => {
    return <Eula languageCode="de" />
}

export default EulaDe
